module.exports = __webpack_public_path__ + "static/media/phone.ec73dc28.png";